export default __webpack_public_path__ + "static/media/french-bread.00648cde.svg";